function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-order_svg__prefix-icon-order-2{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1757",
  transform: "translate(-375 -343)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  fill: "#0571f0",
  "data-name": "Ellipse 74",
  transform: "translate(375 343)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1709"
}, /*#__PURE__*/React.createElement("path", {
  d: "M391 349.982a4.224 4.224 0 00-.027-.545 1.614 1.614 0 00-.573-1.038 1.57 1.57 0 00-1.06-.4c-2.2.013-4.408 0-6.612 0a1.661 1.661 0 00-1.725 1.709v8.993c0 .164.024.311.194.378a.349.349 0 00.407-.125c.289-.309.583-.614.886-.932l.974.977a.327.327 0 00.527 0c.28-.278.558-.557.837-.836.037-.037.076-.071.119-.111l.92.923c.208.208.364.209.569 0l.827-.826c.033-.033.069-.064.121-.114.048.058.082.108.124.149.267.27.537.537.8.807a.3.3 0 00.347.09.319.319 0 00.207-.312v-7.404h1.76a.329.329 0 00.375-.371c.003-.334.003-.672.003-1.012zm-2.551-1.253a2.054 2.054 0 00-.219.956l-.01 8.136v.169a.7.7 0 01-.088-.06l-.514-.512a.325.325 0 00-.543 0l-.827.826c-.034.034-.07.066-.117.11l-.912-.92c-.212-.213-.37-.214-.579-.005l-.816.816c-.034.034-.071.066-.116.108l-.913-.919a.346.346 0 00-.58 0c-.191.191-.38.384-.6.606 0-.09-.01-.14-.01-.19v-8.092a1.038 1.038 0 01.788-1.106.875.875 0 01.2-.024q2.9 0 5.8.008a.46.46 0 01.085.006.683.683 0 01-.028.087zm1.912 2h-1.483c0-.045-.011-.087-.012-.129 0-.33-.014-.66 0-.989a2.32 2.32 0 01.112-.559.7.7 0 01.182-.263.459.459 0 01.6-.1.968.968 0 01.589.84c.03.399.013.793.013 1.205z",
  className: "icon-order_svg__prefix-icon-order-2",
  "data-name": "Path 1169"
}), /*#__PURE__*/React.createElement("path", {
  d: "M387.304 355.404h-4.395c-.261 0-.415.126-.413.332s.151.323.42.323h4.364a.357.357 0 00.323-.145.3.3 0 00.021-.336.333.333 0 00-.32-.174z",
  className: "icon-order_svg__prefix-icon-order-2",
  "data-name": "Path 1170"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.848 351.225h4.473a.322.322 0 00.34-.324.324.324 0 00-.336-.329c-1.5 0-2.992 0-4.488.005a.461.461 0 00-.282.151.275.275 0 00-.016.334.321.321 0 00.309.163z",
  className: "icon-order_svg__prefix-icon-order-2",
  "data-name": "Path 1171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.87 354.433h3.84a.334.334 0 00.371-.4c-.034-.172-.151-.262-.364-.264h-3.809a.38.38 0 00-.353.151.313.313 0 00-.02.337.343.343 0 00.335.176z",
  className: "icon-order_svg__prefix-icon-order-2",
  "data-name": "Path 1172"
}), /*#__PURE__*/React.createElement("path", {
  d: "M385.328 352.168h-2.462a.338.338 0 00-.372.33.324.324 0 00.351.331c.826 0 1.651.005 2.477 0a.461.461 0 00.272-.117.284.284 0 00.056-.343.321.321 0 00-.322-.201z",
  className: "icon-order_svg__prefix-icon-order-2",
  "data-name": "Path 1173"
})));

function SvgIconOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _ref, _ref2);
}

export default SvgIconOrder;